import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CCard = styled(Box)(({ theme }) => ({
  border: "1px solid var(--neutral-300)",
  borderRadius: "8px",
  padding: "16px",
  background: "white",
}));
